import { forwardRef, memo } from 'react';

import type { SelectionRange } from '@gitbook/slate';

/**
 * Virtual selection that sync with the selection.
 */
export const VirtualSelection = memo(
    forwardRef(function VirtualSelection(
        _props: {
            selection: SelectionRange;
        },
        ref: React.ForwardedRef<HTMLDivElement>
    ) {
        const selectionRect = virtualSelectionElement.getBoundingClientRect();
        return (
            <div
                ref={ref}
                className="pointer-events-none absolute select-none"
                style={{
                    transform: `translate(${selectionRect.x}px, ${selectionRect.y}px)`,
                    left: 0,
                    top: 0,
                    width: selectionRect.width,
                    height: selectionRect.height,
                }}
            />
        );
    })
);

const emptyRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
};

// Virtual element used to position the overlay around the selection.
export const virtualSelectionElement = {
    getBoundingClientRect: () => {
        const range = getSelectionRange();
        if (!range) {
            return emptyRect;
        }
        return range.getBoundingClientRect();
    },
    getClientRects: () => {
        const range = getSelectionRange();
        if (!range) {
            return [];
        }
        return range.getClientRects();
    },
};

function getSelectionRange() {
    const selection = window.getSelection();
    if (!selection) {
        return null;
    }
    if (selection.rangeCount === 0) {
        return null;
    }
    return selection.getRangeAt(0);
}
